var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};



//////////////////
// WEBPACK FOOTER
// /app/~/node-libs-browser/~/isarray/index.js
// module id = 49
// module chunks = 0